import { render, staticRenderFns } from "./MemberPrivacy.vue?vue&type=template&id=39be7e31&scoped=true&"
import script from "./MemberPrivacy.vue?vue&type=script&lang=js&"
export * from "./MemberPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./MemberPrivacy.vue?vue&type=style&index=0&id=39be7e31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be7e31",
  null
  
)

export default component.exports